import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import './Speakers from.css';
import amazon from "../../img/SF/amazon.png";
import apple from "../../img/SF/apple.png";
import google from "../../img/SF/google.png";
import meta from "../../img/SF/meta.png";
import Pinterest from "../../img/SF/pinterest.png";
import Salesforce from "../../img/SF/salesforce.png";
import shopify from "../../img/SF/shopify.png";
import snap from "../../img/SF/snap.png";
import netflix from "../../img/SF/netflix.png";
import TikTok from "../../img/SF/tiktok.png";
import Tinder from "../../img/SF/tinder.png";
import Uber from "../../img/SF/uber.png";
import mob_sf from "../../img/SF/mob_sf.png";

const SpeakersFrom = () => {
    const state = {
        Speakers_item: [
            {
                img: amazon,
            },
            {
                img: Uber,
            },
            {
                img: Tinder,
            },
            {
                img: google,
            },
            {
                img: TikTok,
            },
            {
                img: snap,
            },
            {
                img: Salesforce,
            },
            {
                img: Pinterest,
            },
            {
                img: shopify,
            },
            {
                img: netflix,
            },
            {
                img: meta,
            },
            {
                img: apple,
            },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from red_grad">
            <div className='container '>
                <h2>Speakers in our community</h2>
                <div className="speakers_from--content">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
                <img className='sf_all_mob' src={mob_sf} alt="" />
            </div>
        </div>
    );
};

export default SpeakersFrom;